;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.bpu.list')
    .controller('BpuListToolbarController', BpuListToolbarController)

  BpuListToolbarController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function BpuListToolbarController (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes

        // Public Method
      })
    }
  }
})(window.angular, window._)
